var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_vm.as,{tag:"component",staticClass:"grid grid-cols-1 lg:grid-cols-16-fr",class:[_vm.constrained && 'mx-auto w-full max-w-6xl']},[_vm._t("default"),_vm._v(" "),(_vm.navItems.length)?_c('floating-button-mobile',{attrs:{"nav-items":_vm.navItems}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }